<template>
  <div>
    <nav class="toolbox toolbox-pagination" v-if="showPagination">
      <div class="toolbox-item toolbox-show">
        <label>{{ paginationResultsLocalTitle }}</label>
      </div>
      <!-- End .toolbox-item -->
      <ul class="pagination">
        <li class="page-item" :class="{ disabled: prevDisabled }" @click="goToPage(1)">
          <a class="page-link page-link-btn" href="#">
            <i class="icon-angle-double-left" />
          </a>
        </li>
        <li
          class="page-item"
          :class="{ disabled: prevDisabled }"
          @click.prevent.stop="handlePreviousPage"
        >
          <a class="page-link page-link-btn" href="#"><i class="icon-angle-left"></i></a>
        </li>
        <li
          class="page-item"
          :class="{ active: index === pager.currentPage }"
          v-for="index in pages"
          :key="index"
          @click.stop.prevent="goToPage(index)"
        >
          <a class="page-link">{{ index }}</a>
        </li>
        <li
          class="page-item"
          :class="{ disabled: nextDisabled }"
          @click.prevent.stop="handleNextPage"
        >
          <a class="page-link page-link-btn" href="#"><i class="icon-angle-right"></i></a>
        </li>

        <li
          class="page-item"
          :class="{ disabled: nextDisabled }"
          @click.prevent.stop="goToPage(pager.totalPages)"
        >
          <a href="#" class="page-link page-link-btn">
            <i class="icon-angle-double-right" />
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { pager, translations } from '@/mixins';

export default {
  name: 'LocalPagination',
  mixins: [pager, translations],
  data() {
    return {
      actionName: this.action,
    };
  },
  props: {
    action: String,
    totalRecords: Number,
    paginationProps: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    paginationResultsLocalTitle() {
      return this.translations.pagingResults.replace('{fromResults}', this.fromResults)
        .replace('{toResults}', this.toResults)
        .replace('{totalItems}', this.pager.totalItems);
    },
  },
};
</script>

<style lang="scss" scoped>
.page-item:not(.disabled) {
  cursor: pointer;
}

.page-item.disabled {
  cursor: not-allowed;
}
</style>
